import React, { Component } from "react";
import Banner from "../../../components/common/Banner";
import Header from "../../../components/common/Header";
import DepartmentSidebar from "../component/DepartmentSidebar";
import DepartmentAchievers from "../component/DepartmentAchievers";
import DepartmentNumbers from "../component/DepartmentNumbers";
import Footer from "../../../components/common/Footer";
import DepartmentVideo from "../component/DepartmentVideo";

export default class RoboticsAbout extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner
          title="Robotics & Artificial Intelligence"
          image="banners/department-cse.jpg"
        />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <DepartmentAchievers department="robotics" />
                  <DepartmentNumbers
                    text1="Number of students on roll"
                    num1="193"
                    text2="Number of Faculty"
                    num2="6"
                    text3="Number of Faculty with Ph.D"
                    num3="4"
                    text4="Number of Technical Staff"
                    num4="4"
                    text5="Number of Faculties Pursuing Ph.D"
                    num5="2"
                    text6="Number of Patents"
                    num6="4"
                    text7="Number of Publications"
                    num7="35"
                  />
                  <div className="ttm-service-description">
                    <div className="row">
                      <div className="col-md-5">
                        <div className="ttm_single_image-wrapper">
                          <img
                            className="img-fluid"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/departments/robotics/robotics.png"
                            }
                            alt="single-img-eighteen"
                          />
                        </div>
                      </div>
                      <div
                        className="col-md-7 justify"
                        style={{ margin: "auto" }}
                      >
                        <p>
                          Established in the year 1979, the department boasts of
                          well-equipped laboratories and well qualified faculty.
                          The department comprises of VTU recognized R&D Centre,
                          exclusive class rooms, department library with 2417
                          volumes and project laboratories. The department has
                          endeavored in organizing regular field trips to
                          various industries and power stations. Hence giving
                          ample industrial exposure and thus integrating
                          practical & theoretical knowledge in the curriculum.
                          The Department is NBA accredited thrice.
                        </p>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <p>
                          The department has VTU recognized R&D Centre and 6
                          research scholars have registered for Ph.D. Five
                          faculty members of our department have been awarded
                          Ph.D. in diversified areas of EEE.
                        </p>
                      </div>
                    </div>
                  </div>
                  <DepartmentVideo department="cse" />
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Vision</h4>
                    </div>
                    <p>
                      To emerge as a premier center of excellence in Robotics
                      and Artificial Intelligence, committed to delivering
                      quality education, fostering innovation, and empowering
                      students to become leaders in research, industry, and
                      technology-driven entrepreneurship.
                    </p>
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Mission</h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon justify">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To impart quality education in Robotics and Artificial
                          Intelligence through a curriculum aligned with
                          cutting-edge technologies and industry needs.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To promote skill development and practical
                          problem-solving through hands-on learning,
                          interdisciplinary projects, and real-world
                          applications.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To encourage research, innovation, and
                          entrepreneurship by nurturing a culture of inquiry,
                          creativity, and start-up incubation.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To align with national educational goals, including
                          the NEP 2020, by fostering holistic development,
                          critical thinking, and lifelong learning.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To develop socially responsible and ethically grounded
                          professionals capable of leveraging intelligent
                          technologies for societal advancement.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="section-title with-desc text-left clearfix">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">
                        Program Educational Objectives (PEO's)
                      </h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Core Competency : Build a strong foundation in
                          robotics, artificial intelligence, and allied domains
                          to solve real-world engineering problems.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Professional Development : Continuously enhance skills
                          and knowledge to adapt to evolving technologies and
                          pursue higher education, certifications, or
                          professional careers.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Innovation and Research : Engage in interdisciplinary
                          research and development activities leading to
                          innovations, patents, or startups.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Ethical and Social Responsibility : Demonstrate
                          ethical behavior, teamwork, and societal
                          responsibility while designing intelligent systems for
                          sustainable development.
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="ttm-service-single-content-area paddingtop-2">
                    <div className="section-title with-desc text-left clearfix">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h4 className="title">Program Outcomes</h4>
                      </div>
                    </div>
                    <div className="ttm-service-description">
                      <ul className="ttm-list ttm-list-style-icon">
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Engineering Knowledge : Apply the knowledge of
                            mathematics, science, engineering fundamentals, and
                            specialization to solve complex problems
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Problem Analysis : Identify, formulate, research,
                            and analyze engineering problems.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Design/Development of Solutions : Design solutions
                            that meet specific needs with consideration for
                            public health, safety, and cultural/environmental
                            factors.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Conduct Investigations of Complex Problems : Use
                            research methods to conduct investigations of
                            complex problems.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Modern Tool Usage : Use modern tools for engineering
                            practice
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            The Engineer and Society : Understand and apply
                            engineering practice in the context of societal,
                            ethical, and environmental considerations.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Environment and Sustainability : Apply environmental
                            and sustainable engineering principles.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Ethics : Understand ethical principles and
                            responsibilities.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Individual and Team Work : Work effectively as a
                            member and leader in diverse teams.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Communication : Communicate effectively on complex
                            engineering topics.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Project Management and Finance : Apply engineering
                            and management principles in project management.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Life-long Learning : Recognize the need for and have
                            the ability to engage in life-long learning.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Program Specific Outcomes</h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Apply the principles of robotics, control systems,
                          artificial intelligence, and embedded technologies to
                          design and implement intelligent and autonomous
                          systems.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Conduct research and apply innovative approaches to
                          solve real-world problems using AI-driven and robotic
                          technologies, contributing to academic, industrial, or
                          entrepreneurial outcomes.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Demonstrate ethical responsibility, teamwork, and
                          communication skills to deliver sustainable,
                          inclusive, and socially relevant AI and robotic
                          solutions.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DepartmentSidebar department="robotics" />
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
